import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/语句2.png';
const _hoisted_1 = {
  class: "search-header"
};
const _hoisted_2 = {
  class: "search-logo"
};
const _hoisted_3 = {
  key: 0,
  class: "user-menu-container"
};
const _hoisted_4 = {
  key: 1,
  class: "login-register-button"
};
const _hoisted_5 = {
  key: 2,
  class: "search-container"
};
import SearchBar from '@/components/SearchBar.vue';
import UserMenu from '@/components/UserMenu.vue';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import { storeToRefs } from 'pinia';
//状态
export default /*@__PURE__*/_defineComponent({
  __name: 'SearchHeader',
  setup(__props) {
    const router = useRouter();
    const homeLogo = ref(null);
    const userStore = useUserStore();
    const {
      isLoggedIn
    } = storeToRefs(userStore);
    onMounted(() => {
      homeLogo.value.addEventListener('click', () => {
        router.push('/');
      });
    });
    const toLogin = () => {
      router.push('/login');
    };
    const toRegister = () => {
      router.push('/register');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "logo",
        ref_key: "homeLogo",
        ref: homeLogo
      }, _cache[0] || (_cache[0] = [_createElementVNode("img", {
        src: _imports_0,
        alt: "医疗系统标识"
      }, null, -1)]), 512)]), _unref(isLoggedIn) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(UserMenu)])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", {
        onClick: toLogin
      }, "登录"), _cache[1] || (_cache[1] = _createTextVNode(" / ")), _createElementVNode("span", {
        onClick: toRegister
      }, "注册")])), false ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(SearchBar, {
        placeholderText: '搜索病例/课件/微课...'
      })])) : _createCommentVNode("", true)]);
    };
  }
});